import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M12.334 6.333H14V8a1 1 0 0 1-1 1h-.333v.333a1 1 0 0 1-1 1h-.333v.334a1 1 0 0 1-1 1h-3l-1.96 1.96a1 1 0 0 1-1.414 0l-1.92-1.92a1 1 0 0 1 0-1.414l.627-.626V7l3-3.08m6.667 2.413H8c0 .778-.234 2-1.333 2-1 0-1.333-1-1.333-2 0-.63 0-1.656.333-2.413m6.667 2.413 1.292-1.293a1 1 0 0 0 0-1.414L11.98 1.98a1 1 0 0 0-1.347-.061L9.334 3c-.445-.111-1.6-.267-2.667 0-.494.123-.804.475-1 .92"
    }, null, -1)
  ])))
}
export default { render: render }